import { useMemo } from 'react'
import { EventType } from 'types/Event'

export const useClosestEvents = (events: EventType[] | undefined, count: number) => {
    const closestEvents = useMemo(() => {
        if (!events) return []

        const currentDate = new Date()

        return [...events]
            .filter((event) => new Date(event.event_date) >= currentDate)
            .sort((a, b) => new Date(a.event_date).getTime() - new Date(b.event_date).getTime())
            .slice(0, count)
    }, [events, count])

    return closestEvents
}
